import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader, authHeaderJson } from '../_helpers/auth-header';

import  config  from '../config';
const base_url = config.apiUrl;

const model = 'users/';

export const usersService = {
  getAll,
  getAllByUserType,
  getById,
  add,
  edit,
  checkUserName,
  checkEmail,
  delete: _delete,
  toggleStatus
};

function getAll() {
  const url = base_url + model;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function getAllByUserType(userType) {
  const url = base_url + model + 'getAllByUserType/' + userType;
  console.log(url, userType);
  
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function getById(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function checkUserName(userName) {
  const url = base_url + 'AspNetUsers/checkUserName/' + userName;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function checkEmail(email) {
  const url = base_url + 'AspNetUsers/checkEmail/' + email;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function add(dto) {
  const url = base_url + model + 'addUser';
  axios.interceptors.response.use(handleSuccess, handleError);
  let user = JSON.parse(localStorage.getItem('user'));

  let headers = { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + user.token };
  return axios.post(url, dto, { headers: headers});
}

function edit(id, form) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.put(url, form, { headers: authHeaderJson()});
}

function toggleStatus(dto) {
  const url = base_url + model + 'toggleStatus';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, dto, { headers: authHeaderJson()});
}

function _delete(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader()});
}
